export const FONTS = [
  'Press Start 2P',
  'Roboto:400,700',
  'Orbitron:400,700',
  'Crimson Pro:400,700',
  'Quicksand:400,500,600'
]
